// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BlS9","right":"styles_right__2QB_Q"};